/**
 * Utility helper to reliably fetch the Verisoul session ID on the frontend.
 * Polls until window.Verisoul is ready (up to timeoutMs) so tokens are never missed
 * even if a user submits a form right as the page opens.
 */
export const getVerisoulSessionId = async (timeoutMs: number = 2000): Promise<string> => {
  const startTime = Date.now();

  // Wait/poll until window.Verisoul is initialized or timeout is reached
  while (!(window as any).Verisoul && (Date.now() - startTime) < timeoutMs) {
    await new Promise((resolve) => setTimeout(resolve, 50));
  }

  if ((window as any).Verisoul) {
    try {
      const session = await (window as any).Verisoul.session();
      const sessionId = session?.session_id || (typeof session === 'string' ? session : '');
      if (!sessionId) {
        throw new Error('[Verisoul Error] Verisoul.session() returned an empty session ID.');
      }
      return sessionId;
    } catch (err) {
      console.error('[Verisoul] Error fetching session ID:', err);
      throw err;
    }
  } else {
    console.error('[Verisoul ERROR] window.Verisoul was not ready after timeout.');
    throw new Error('[Verisoul ERROR] window.Verisoul SDK failed to initialize. Check REACT_APP_VERISOUL_PROJECT_ID and network connection.');
  }
};
